export function serializeFrustum(frustum, arr) {
  // const arr = new Float32Array(24);
  let i = 0
  for (const p of frustum.planes) {
    arr[i++] = p.normal.x
    arr[i++] = p.normal.y
    arr[i++] = p.normal.z
    arr[i++] = p.constant
  }
  return arr
}

export function deserializeFrustum(arr, frustum) {
  for (let i = 0; i < 6; i++) {
    const plane = frustum.planes[i]
    const normal = plane.normal // reuse the existing Vector3
    normal.x = arr[i * 4 + 0]
    normal.y = arr[i * 4 + 1]
    normal.z = arr[i * 4 + 2]
    plane.constant = arr[i * 4 + 3]
  }
  return frustum
}
